export default __webpack_public_path__ + "static/media/nature-background-1.85a71809.jpg";